export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9438.3ddb41aa.jpg";